import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Baseproperties } from 'src/app/views/utility/baseproperties';
import { Hub } from '../../utility/modals';


@Injectable({
  providedIn: 'root'
})
export class HubService {

  baseproperties: Baseproperties = new Baseproperties(); 

  private baseURL = this.baseproperties.gatewayBaseURL+"/common"
  scrollHeight: string = '22em'; 
  constructor(private httpClient: HttpClient,private route:Router) { }
  //DepartmentService

getOptionDropdown(length):Array<any>{
  let options=[]
  let pairSize = 10;
  let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
  let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
    const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
    return [end];
  });
  pairsArray.map((e)=>{
    options.push({'label':e[0],value:e[0]})
  });
  return options
}

//Add New Regions
addHub(hub): Observable<Object>{
  return this.httpClient.post(`${this.baseURL}/gen/addhub`, hub);
}
getHubById(id: number, number: any): Observable<Hub>{
  return this.httpClient.get<Hub>(`${this.baseURL}/gen/gethubbyid/${id}`);
}
updateHubs(hub: Hub): Observable<Object>{
  return this.httpClient.post(`${this.baseURL}/gen/modifyhub`, hub);
  }
  getHubData(): Observable<any> {
      return this.httpClient.get(`${this.baseURL}/gen/viewhub`);
    }
    hubDataExcel()
{
  
   return this.httpClient.get(`${this.baseURL}/gen/hubdataexcel`,{ responseType: 'blob' }); 
}
}
